/**
 * Newsroom Page Module
 *
 * @description
 * <p>Handles Newsroom page filter menus and overlays</p>
 * <p>On page load, sets up click functions for .newsroom-btn objects</p>
 * <p>Self-initializes when you include this module.</p>
 *
 * @module page-newsroom
 *
 * @namespace site.newsroom
 *
 */
;( /* @lends module:page-newsroom */ function(site,$){
	"use strict";

	var trace = {push: function() {}},
		dom = {},
		data = [],
		next = 0,
		current = 0,
		page = 0,
		has_newsrooms = true,
		year = '',
		month = '',
		news_type = 'All',
		brand = 'All',
		keyword='',
		brand_peacock = 'All',
		multi_brand = false,
		filter_tags = 'All',
		page_count = 0,
		news_total_count = 0;

	function init() {
		var newsroom_path_type = location.pathname.split("/");


        $(document).ready(function () {
            if ($(".newsroom-listicle")[0]){
                if ($(".newsroom_listicle_banner .news-listicle-card")[0]){
                    $('.news-listing-section').removeClass('no-banner');
                } else {
                    $('.newsroom-listicle .news-listing-section').addClass('no-banner');
                }
            }
            $('body').on('click', '.news-tags.plus-tags', function(){
                $(this).hide();
                $(this).parent('.news-tag-wrap').children('.more-tags').show();

            });
        });

		if(newsroom_path_type[1] == "newsroom" && $(".newsroom_landing_list")[0]) {
            dom.twocard = $('.news-two-col');
            dom.threecard = $('.news-three-col');
            dom.loading = $('.newsroom_loading');
            dom.show_result_btn = $('.news-listing-section .show-result-btn');
            var isMobile = site.checkMobile();
            //var page_count = 0;
            $(document).ready(function () {
                // newsroom filter list onclick show event
                $("#news-filter-menu").click(function () {
                    $(".filter-list-wrapper").css({"opacity":"1", "visibility": "visible"});
                });

                $("#hide-filter").click(function () {
                    $(".filter-list-wrapper").css({"opacity":"0", "visibility": "hidden"});
                });
                // newsroom filter accordion related event
                $('.filter-article-heading').click(function (e) {
                    e.preventDefault();
                    let $this = $(this);
                    if ($this.parent().hasClass('active')) {
                        $this.parent().removeClass('active');
                        $this.next().slideUp(350);
                    } else {
                        $this.next().slideToggle(350);
                        $this.parent().toggleClass('active');
                    }
                });
            });
            $(".filter-article-details .filter-checkbox input[type=checkbox]").on("click", function (e) {
                let $this = $(this);
                if($this.is(":checked")) {
                    $this.addClass('checked');
                } else {
                    $this.removeClass('checked');
                }
            });

            $(".filter-btn-grp .filter-list-result").on("click", function (e) {
                var count = 0;
                var filterArr = "";
                var filterTagArr = [];
                var filterNameArr = "";
                page_count = 0;
                news_total_count = 0;
                if($(".filter-article-details .filter-checkbox .checked").length == 0) {
                    $(".filter_error_message").show();
                    return false;
                } else {
                    $(".filter_error_message").hide();
                }
                $(".filter-article-details .filter-checkbox .checked").each(function(el){
                    var filterValue = $(this).val();
                    var filterName = $(this).attr('data-name');
                    if($(this).parents('.parent').length) {
                        $(this).parents('.parent').parent('.filter-accordion-info').find("input[type=checkbox]").each(function(el){
                            filterTagArr.push($(this).val());
                        });
                    }
                    filterTagArr.push(filterValue);
                    filterNameArr+= filterName+', ';
                });
                var uniqueFilterArr = filterTagArr.filter(function(elem, index, self) {
                    return index === self.indexOf(elem);
                });
                uniqueFilterArr.forEach(function(item) {
                    filterArr+='&filter_tags[' + count + ']='+item;
                    count++;
                });
                if(count>0) {
                    filter_tags = filterArr;
                    dom.twocard.hide();
                } else {
                    filter_tags = 'All';
                    dom.twocard.show();
                }
                filterNameArr = "Results for " +filterNameArr.slice(0,-2);
                dom.show_result_btn.hide();
                dom.threecard.empty();
                dom.loading.show();
                $("#hide-filter").click();
                getNewsroomFeed();
                if(isMobile) {
                    $('.news-listing-section .filter-result-txt').empty().html(filterNameArr).show();
                } else {
                    $('.news-listing-section .news-filter-row h4').empty().html(filterNameArr).show();
                }

            });
            $(".filter-btn-grp .filter-list-clear").on("click", function (e) {
                filter_tags = 'All';
                page_count = 0;
                news_total_count = 0;
                $(".filter-article-details .filter-checkbox .checked").each(function(el){
                    $(this).prop('checked', false);
                    $(this).removeClass('checked');
                });
                dom.show_result_btn.hide();
                dom.twocard.hide();
                dom.threecard.empty();
                dom.loading.show();
                $("#hide-filter").click();
                getNewsroomFeed();
                if(isMobile) {
                    $('.news-listing-section .filter-result-txt').empty().html('').hide();
                } else {
                    $('.news-listing-section .news-filter-row h4').empty().html("News").show();
                }
            });

            $(".news-listing-section .show-result-btn").on("click", function (e) {
                e.preventDefault();
                page_count++;
                dom.loading.show();
                getNewsroomFeed();
            });
            // dom.twocard.hide();
            dom.show_result_btn.hide();
            dom.loading.show();
            console.log(page_count);
            getNewsroomFeed();
        }
	}

	function getNewsroomFeed() {
		var filter_flag = 0;
		if(filter_tags == "All") {
			filter_tags = "&filter_tags="+filter_tags;
			filter_flag = 1;
		}

		var filters = "&page="+page_count+filter_tags;
        console.log(filters);
        console.log(filter_flag);
        $.ajax({
			url: '/newsroom_landing_list',
			type: 'POST',
			dataType: 'json',
			data: { filter_tags: encodeURIComponent(filters), filter_flag: filter_flag, count_filter: encodeURIComponent(filter_tags)},
			success: function(ajaxdata) {
				dom.loading.hide();
				if(filter_flag) {
					// dom.twocard.show();
				}
                if(page_count != 0){
                    var append = encodeURIComponent(ajaxdata.newroom_three_col);
                    dom.threecard.append(decodeURIComponent(append));
                }
				news_total_count = (news_total_count+ajaxdata.newsroom_list_count <= ajaxdata.newsroom_total_count) ? news_total_count+ajaxdata.newsroom_list_count : ajaxdata.newsroom_total_count;

                if(ajaxdata.newsroom_total_count == news_total_count) {
					dom.show_result_btn.hide();
				} else {
					dom.show_result_btn.show();
				}

				if(ajaxdata.newsroom_list_count == 0 && page_count==0) {
					$('.newsroom_no_result').show();
				} else {
					$('.newsroom_no_result').hide();
				}
			}
		});
	}

	$(function(){
		init();
	});
})(window.site=window.site || {}, jQuery);